/*
 * Copyright © 2022 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UpgradeModule } from '@angular/upgrade/static';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    // FcAgAuthenticationInterceptor,
    FcResponsiveAgGridModule,
    FcResponsiveAgDialogModule,
    // FcResponsiveAgDropDownListModule,
    FcAgLoadingMaskModule,
    FcAgContextModule,
    // FcAgDatePickerModule,
    // FcTooltipModule,
    FcAccordionModule
} from 'ag-libraries';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { SafeHtmlPipe, SortByPipe, SortByCasePipe } from './app.pipe';
import {
    FcPreviewDocumentFileFormComponent
} from './fc-preview-document-file-form/fc-preview-document-file-form.component';
import {
    FcAddMoreDocumentFileFormComponent
} from './fc-add-more-document-file-form/fc-add-more-document-file-form.component';

const PIPE = [SafeHtmlPipe, SortByPipe, SortByCasePipe];

/**
 * App module with Angular.
 */
@NgModule({
    declarations: [
        ...PIPE,
        AppComponent,
        FcPreviewDocumentFileFormComponent,
        FcAddMoreDocumentFileFormComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        UpgradeModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot(),
        ReactiveFormsModule,
        // FcAgAuthenticationInterceptor,
        FcResponsiveAgGridModule,
        FcResponsiveAgDialogModule,
        // FcResponsiveAgDropDownListModule,
        FcAgLoadingMaskModule,
        FcAgContextModule,
        // FcAgDatePickerModule,
        // FcTooltipModule,
        FcAccordionModule
    ],
    providers: [DatePipe],
    bootstrap: [AppComponent]
})
export class AppModule {
    /**
     * App constructor.
     *
     * @param upgrade UpgradeModule.
     */
    constructor(private upgrade: UpgradeModule) {}
}
